import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {useSelector, useDispatch} from 'react-redux';
import ObservationCard from './ObservationCard';
import './ListaAvistamentos.css';
import { useBottomScrollListener } from 'react-bottom-scroll-listener';
import {fetch_avistamentos_user, fetch_avistamentos_extra_user, clear_avistamentos_user, fetch_validate, clear_avistamentos_validate, fetch_avistamentos_extra_validate} from '../redux/actions';



function ListaAvistamentos(props){

    const [observations, setObservations] = useState([]);
    
   
    const avistamentosUser = useSelector(state => state.avistamentosUser);
    const avistamentosValidate = useSelector(state => state.validate);
    const dispatch = useDispatch();
    const userData = useSelector(state => state.userStatus.profile)
    const userDataAdmin = useSelector(state => state.usersList.editingUser)
    const deletingState = useSelector(state => state.editObservation.deletingObservationStatus);
    const editingState = useSelector(state => state.editObservation.validatingObservationStatus);
    
    useEffect(() => {
        switch(props.tipo){
            case 'utilizador':
                if(deletingState==='WAITING'){
                    dispatch(fetch_avistamentos_user(userData.id))
                }
                break
            case 'administrador':
                if(deletingState==='WAITING'){
                    dispatch(fetch_avistamentos_user(userDataAdmin._id))
                }
                break
            case 'validar':
                if(editingState==='WAITING'){
                    dispatch(fetch_validate(avistamentosValidate.filtroConcelho))
                }
                break

        }
        
    }, [deletingState, editingState, avistamentosValidate.filtroConcelho])

    useEffect(() => {
        
        if(props.tipo ==='utilizador' || props.tipo ==='administrador' && avistamentosUser.mainStatus === 'LOADED' || avistamentosUser.extraStatus === 'LOADED'){
          
            const avistamentosDisp = avistamentosUser.avistamentos.map(avistamento => {
                
              let tipo='';
              let keys = Object.keys(avistamento.properties)
              if(keys.includes('n_ovos')){
                tipo='aninhamento'
              } else if(keys.includes('especie')){
                tipo='avistamento'
              } else if(keys.includes('alvo')){
                tipo='ataque'
              }

              return {
                data: new Date(avistamento.properties.data),
                id:avistamento._id,
                tipo: tipo,
                properties: avistamento.properties,
                coordinates:avistamento.geometry.coordinates
              }
          }
            )

            setObservations(avistamentosDisp)
        }
    }, [avistamentosUser.mainStatus, avistamentosUser.extraStatus])

    useEffect(() => {
        
        if(props.tipo ==='validar' && avistamentosValidate.mainStatus === 'LOADED' || avistamentosValidate.extraStatus === 'LOADED'){
          
            const avistamentosDisp = avistamentosValidate.avistamentos.map(avistamento => {
                
              let tipo='';
              let keys = Object.keys(avistamento.properties)
              if(keys.includes('n_ovos')){
                tipo='aninhamento'
              } else if(keys.includes('especie')){
                tipo='avistamento'
              } else if(keys.includes('alvo')){
                tipo='ataque'
              }

              return {
              data: new Date(avistamento.properties.data),
              id:avistamento._id,
              tipo: tipo,
              properties: avistamento.properties,
              coordinates:avistamento.geometry.coordinates
            }
          }
            )
            setObservations(avistamentosDisp)
        }
    }, [avistamentosValidate.mainStatus, avistamentosValidate.extraStatus])

    useEffect(() => {
        
        if(props.tipo==='utilizador' || props.tipo==='administrador'){
            return () => dispatch(clear_avistamentos_user());
        }else if(props.tipo==='validar'){
            return () => dispatch(clear_avistamentos_validate());
        }else{
            return null
        }
        

      }, []);

    const scrollRef = useBottomScrollListener(handleBottomReach, {debounce:1000});

    function handleBottomReach(){

        const date = new Date()
        let last_dates = {avistamento: date, aninhamento:date, ataque:date}
        observations.forEach(obs => {last_dates[obs.tipo] = obs.data})

        switch(props.tipo){

            case 'utilizador':
                
                if(props.n_obs > observations.length && avistamentosUser.extraStatus !== 'LOADING'){
                    dispatch(fetch_avistamentos_extra_user(userData.id, last_dates))
                }
                
                break 
            case 'administrador':
            
                if(15 > observations.length && avistamentosUser.extraStatus !== 'LOADING'){
                    dispatch(fetch_avistamentos_extra_user(userData.id, last_dates))
                }
                
                break 
            case 'validar':
                if(avistamentosValidate.total > observations.length && avistamentosValidate.extraStatus !== 'LOADING'){
                    dispatch(fetch_avistamentos_extra_validate(last_dates, avistamentosValidate.filtroConcelho))
                }
                break
            default:
                break

        }
       

        
    }
    

    const userObs = observations.map((marker) =>(
        <ObservationCard
            key={marker.id}
            id={marker.id}
            coords={marker.coordinates}
            tipo={marker.tipo}
            properties={marker.properties}
            card_type = {props.tipo}
        />
    )
);

    return(
        <div className={props.tipo==='validar'?'lista-avistamentos-validate':'lista-avistamentos'} ref={scrollRef}>
            <div className='observationsGrid' >
                {userObs}
            </div>
            <div>
                {/* {avistamentosUser.mainStatus === 'LOADING' || avistamentosUser.extraStatus === 'LOADING'?<Loader
                type='TailSpin'
                color='#0dafd0ff'
                height='40'
                width='40'
            
                />:null}
                {avistamentosValidate.mainStatus === 'LOADING' || avistamentosValidate.extraStatus === 'LOADING'?<Loader
                type='TailSpin'
                color='#0dafd0ff'
                height='40'
                width='40'
            
                />:null} */}
            </div>
        </div>
    )
}


ListaAvistamentos.propTypes = {
    observations: PropTypes.array,
    edit: PropTypes.func.isRequired,
    handleDelete: PropTypes.func.isRequired,
    handleScroll: PropTypes.func.isRequired
}

export default ListaAvistamentos;